// extracted by mini-css-extract-plugin
export default {"addBtn":"styles_addBtn__xaZSJ","selectWrapper":"styles_selectWrapper__J01Hg"};